export default __webpack_public_path__ + "public/fonts/info-icon.svg";